import { Directive, inject, OnDestroy, OnInit } from '@angular/core';
import { SiaSizeDetectorService } from '../services/size-detector.service';

@Directive({
  selector: '[disableTooltips]',
})
export class DisableTooltipsDirective implements OnInit, OnDestroy {
  private sizeDetector = inject(SiaSizeDetectorService);

  private observer: MutationObserver | null = null;

  ngOnInit() {
    // console.log('disableTooltips directive initialized');
    if (!this.sizeDetector.isHoverable) {
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            // Se il nodo è un tooltip di Material, nascondilo o rimuovilo
            // console.log('nuovo nodo', node);
            if (node.nodeType === Node.ELEMENT_NODE) {
              const element = node as Element;
              // Controlla se il componente è un mat-tooltip-component
              if (element.tagName.toLowerCase() === 'mat-tooltip-component') {
                // Fai qualcosa con il mat-tooltip-component appena inserito
                // console.log('Trovato nuovo mat-tooltip-component:', element);
                element.remove();
              }
            }
          });
        });
      });
      this.observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
      });
    }
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }
}
